import React, { useEffect } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import TagManager from 'react-gtm-module';

// Componentes Bootstrap
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Componentes de Funcionalidade
import ArenasList from "./components/arenas-list.component";
import Arena from "./components/arena.component";
import Place from "./components/place.component";

// Páginas Institucionais
import About from "./pages/about.component";
import HowItWorks from "./pages/how-it-works.component";
import Sponsorship from "./pages/sponsorship.component";
import Contact from "./pages/contact.component";

import CropVideo from "./components/crop-video.component";

// Configuração do GTM
const tagManagerArgs = {
  gtmId: 'GTM-KM8XSBBN',
  dataLayer: {
    appName: 'Replay Pro'
  }
};

if (typeof window !== 'undefined') {
  TagManager.initialize(tagManagerArgs);
}

const App = () => {
  const location = useLocation();

  const getPageTitle = (pathname) => {
    const pathSegments = pathname.split('/').filter(Boolean);
    if (pathSegments.length >= 4) {
      const [, , name, place] = pathSegments;
      return `Replay Pro - ${decodeURIComponent(name)} - ${decodeURIComponent(place)}`;
    }
    if (pathSegments.length >= 3) {
      const [, , name] = pathSegments;
      return `Replay Pro - ${decodeURIComponent(name)}`;
    }
    return 'Replay Pro';
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pageTitle = getPageTitle(location.pathname);
      document.title = pageTitle;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.search,
        page_title: pageTitle,
        page_location: window.location.href
      });
    }
  }, [location]);


  // Função auxiliar para verificar se a rota está ativa
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Navbar collapseOnSelect expand="lg" className="navbar-grey bg-grey fixed-top border-bottom">
        <Container>
          <Navbar.Brand as={Link} to="/" className="replay-pro-logo">
            <img src='/images/replay-pro-logo.svg' alt="Replay Pro Logo" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
            <Nav className="ms-auto align-items-lg-center">
              <Nav.Link
                as={Link}
                eventKey="0"
                to="/"
                className={`text-danger nav-link-custom ${isActive('/') ? 'nav-link-active' : ''}`}
              >
                Home - Arenas
              </Nav.Link>
              <Nav.Link
                as={Link}
                eventKey="1"
                to="/sobre"
                className={`text-danger nav-link-custom ${isActive('/sobre') ? 'nav-link-active' : ''}`}
              >
                Sobre a Replay Pro
              </Nav.Link>
              <Nav.Link
                as={Link}
                eventKey="2"
                to="/como-funciona"
                className={`text-danger nav-link-custom ${isActive('/como-funciona') ? 'nav-link-active' : ''}`}
              >
                Como Tudo Funciona
              </Nav.Link>
              <Nav.Link
                as={Link}
                eventKey="3"
                to="/patrocinio"
                className={`text-danger nav-link-custom ${isActive('/patrocinio') ? 'nav-link-active' : ''}`}
              >
                Seja um Patrocinador
              </Nav.Link>
              <Nav.Link
                as={Link}
                eventKey="4"
                to="/contato"
                className={`text-danger nav-link-custom ${isActive('/contato') ? 'nav-link-active' : ''}`}
              >
                Fale com a Gente
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="container">
        <Routes>
          <Route path="/" element={<ArenasList />} />
          <Route path="/arenas" element={<ArenasList />} />
          <Route path="/arenas/:id/:name" element={<Arena />} />
          <Route path="/arenas/:id/:name/:place" element={<Place />} />
          <Route path="/arenas/:id/:name/:place/:date" element={<Place />} />
          <Route path="/arenas/:id/:name/:place/:date/:hour" element={<Place />} />

          <Route path="/arenas/:id/:name/:place/:date/:hour/crop/:videoName" element={<CropVideo />} />

          <Route path="/sobre" element={<About />} />
          <Route path="/como-funciona" element={<HowItWorks />} />
          <Route path="/patrocinio" element={<Sponsorship />} />
          <Route path="/contato" element={<Contact />} />
        </Routes>
      </div>

      <footer className="pb-3 mt-5 footer">
        <div className="container pb-2">
          <Row className="align-items-start">
            <Col className="col-4 col-md-3 col-xl-2 col">
              <img src='/images/replay-pro-white.svg' width="100%" alt="Replay Pro Logo" />
            </Col>
            <Col className="col-0 d-none d-md-block col-md-2 col-xl-3 col"></Col>
            <Col className="col-8 col-md-7 col-xl-7 col">
              <div className="text-right">
                <span className="slogan-main">REVIVA A EMOÇÃO!</span>
                <span className="slogan-desc"> COMPARTILHE MOMENTOS INESQUECÍVEIS!</span>
              </div>
            </Col>
          </Row>
          <a
            href="https://incit.com.br/project/replaypro/"
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center justify-content-center mt-2 text-decoration-none hover-opacity"
          >
            <img src='/images/selo-incubada.png' alt="Selo Incit" height="120" className="d-inline-block p-2" />
            <img src='/images/selo-hard-tech.png' alt="Selo Hard Tech" height="120" className="d-inline-block p-2" />
            <span className="text-light p-2" style={{ fontSize: '1rem' }}>
              Startup Incubada: Incit
            </span>
          </a>
        </div>
        <div className="text-center pt-2">©{new Date().getFullYear()} Replay Pro. Todos os direitos reservados.</div>
      </footer>
    </>
  );
};

export default App;